import { render, staticRenderFns } from "./TambahProgress.vue?vue&type=template&id=b3e9e68e&scoped=true"
import script from "./TambahProgress.vue?vue&type=script&lang=js"
export * from "./TambahProgress.vue?vue&type=script&lang=js"
import style0 from "./TambahProgress.vue?vue&type=style&index=0&id=b3e9e68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e9e68e",
  null
  
)

export default component.exports